import axios from "axios";
import DraftEntityTypes from "../../../../enums/draftEntityTypes";

const service = {
  createLock: async (entityType, payload) => {
    const createLockRequest = {
      payload: JSON.stringify(payload),
    };

    const urls = {
      [DraftEntityTypes.Videos]: `/api/assets/videos`,
      [DraftEntityTypes.Assessments]: `/api/assets/assessments`,
      [DraftEntityTypes.Surveys]: `/api/assets/surveys`,
      [DraftEntityTypes.Pdfs]: `/api/assets/pdfs`,
      [DraftEntityTypes.Events]: `/api/external-events`,
      [DraftEntityTypes.Emails]: `/api/communications/emails`,
      [DraftEntityTypes.Messages]: `/api/communications/messages`,
      [DraftEntityTypes.Campaigns]: `/api/v2/threat-defence/campaigns`,
      [DraftEntityTypes.EmbeddedVideos]: `/api/assets/embedded-videos`,
      [DraftEntityTypes.Links]: `/api/assets/links`,
    };

    const url = urls[entityType] || `/api/${entityType}`;

    return axios.post(url, createLockRequest);
  },
  getEntityLock: async (entityType, entityId) => {
    const urls = {
      [DraftEntityTypes.Videos]: `/api/v2/assets/videos/${entityId}/edit`,
      [DraftEntityTypes.Assessments]: `/api/v2/assets/assessments/${entityId}/edit`,
      [DraftEntityTypes.Surveys]: `/api/v2/assets/surveys/${entityId}/edit`,
      [DraftEntityTypes.Pdfs]: `/api/assets/pdfs/${entityId}/edit`,
      [DraftEntityTypes.Events]: `/api/v2/external-events/${entityId}/edit`,
      [DraftEntityTypes.Emails]: `/api/v2/communications/emails/${entityId}/edit`,
      [DraftEntityTypes.Messages]: `/api/communications/messages/${entityId}/edit`,
      [DraftEntityTypes.EmbeddedVideos]: `/api/assets/embedded-videos/${entityId}/edit`,
      [DraftEntityTypes.Campaigns]: `/api/v2/threat-defence/campaigns/${entityId}/edit`,
      [DraftEntityTypes.Links]: `/api/assets/links/${entityId}/edit`,
    };

    const url = urls[entityType] || `/api/v2/${entityType}/${entityId}/edit`;

    return axios.post(url);
  },
  releaseLock: async (entityType, entityId, payload) => {
    const urls = {
      [DraftEntityTypes.Videos]: `/api/assets/videos/${entityId}/publish`,
      [DraftEntityTypes.Assessments]: `/api/assets/assessments/${entityId}/publish`,
      [DraftEntityTypes.Surveys]: `api/assets/surveys/${entityId}/publish`,
      [DraftEntityTypes.Pdfs]: `api/assets/pdfs/${entityId}/publish`,
      [DraftEntityTypes.Events]: `/api/external-events/${entityId}/publish`,
      [DraftEntityTypes.Emails]: `/api/communications/emails/${entityId}/publish`,
      [DraftEntityTypes.Messages]: `api/communications/messages/${entityId}/publish`,
      [DraftEntityTypes.Campaigns]: `api/v2/threat-defence/campaigns/${entityId}/publish`,
      [DraftEntityTypes.EmbeddedVideos]: `/api/assets/embedded-videos/${entityId}/publish`,
      [DraftEntityTypes.Links]: `/api/assets/links/${entityId}/publish`,
    };

    const url = urls[entityType] || `/api/${entityType}/${entityId}/publish`;

    return axios.post(url, payload);
  },
  discardLock: async (entityType, entityId) => {
    const urls = {
      [DraftEntityTypes.Videos]: `/api/assets/videos/${entityId}/revert`,
      [DraftEntityTypes.Assessments]: `/api/assets/assessments/${entityId}/revert`,
      [DraftEntityTypes.Surveys]: `api/assets/surveys/${entityId}/revert`,
      [DraftEntityTypes.Pdfs]: `api/assets/pdfs/${entityId}/revert`,
      [DraftEntityTypes.Events]: `/api/external-events/${entityId}/revert`,
      [DraftEntityTypes.Emails]: `/api/communications/emails/${entityId}/revert`,
      [DraftEntityTypes.Messages]: `api/communications/messages/${entityId}/revert`,
      [DraftEntityTypes.EmbeddedVideos]: `/api/assets/embedded-videos/${entityId}/revert`,
      [DraftEntityTypes.Campaigns]: `/api/v2/threat-defence/campaigns/${entityId}/revert`,
      [DraftEntityTypes.Links]: `/api/assets/links/${entityId}/revert`,
    };

    const url = urls[entityType] || `/api/${entityType}/${entityId}/revert`;

    return axios.post(url);
  },
};

export default service;
